<template>
  <div class="k-filter-dropdown">
    <KkDropdown ref="KkDropdownRef">
      <div class="body">
        <slot name="body"></slot>
      </div>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </KkDropdown>
  </div>
</template>

<script>
import { KkDropdown } from '@kkday/web-design-system'

export default {
  components: {
    KkDropdown
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
.k-filter-dropdown {
  position: absolute;
  width: 100%;
  height: 400px;
  left: 0px;
  z-index: 2001;
  margin-top: 5px;
  .kk-select-dropdown--auto-width {
    width: 100% !important;
    max-width: none !important;
    overflow: visible;
    ::v-deep .kk-select-dropdown__content {
      padding: 0px !important;
      max-height: none;
      overflow-y: unset !important;
    }
  }
  .body {
    padding: var(--kk-spacing-8) var(--kk-spacing-7);
  }
  .footer {
    padding: var(--kk-spacing-7);
  }
}
</style>
